import { Button, Col, Container, Dropdown, Form, Row, Stack } from "react-bootstrap";
import { InsightCard } from "@/ui/InsightCard";
import { InsightItem } from "@/ui/InsightItem";
import clsx from "classnames";
import classes from "./styles.module.scss";
import Search from "@/assets/Search.svg";
import { useEffect, useState } from "react";
import { useLocale } from "@/hooks/useLocale";
import { DynamicText } from "@/ui/DynamicText";
import { placeholders } from "@/data/placeholders";
import { tags } from "@/data/insightTags";
import { useLink } from "@/hooks/useLink";
import { insights_helper } from "@/helpers/insights_helper";

export const InsightsPageFeedSection = ({ className, tag }) => {
  const locale = useLocale();
  const link = useLink();
  const [perPage] = useState(10);
  const [page, setPage] = useState(1);
  const [items] = useState(
    insights_helper.fetch({ filter: (i) => (!tag ? true : !i?.tags ? false : i.tags.includes(tag.label)) })
  );
  const [show, setShow] = useState(false);
  const [query, setQuery] = useState(null);
  const [[item1, item2, ...rest], setComputedItems] = useState([]);

  useEffect(() => {
    setComputedItems(
      items
        .filter((i) => (query ? i[`title_${locale}`].toLowerCase().includes(query.toLowerCase()) : true))
        .slice(0, perPage * page)
    );
  }, [tag, items, query, locale, page, perPage]);

  return (
    <div className={className}>
      <Container>
        <Form
          className={clsx(classes.form, "bg-white-50 mb-4")}
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Stack className={clsx(classes.form__search, "p-3 pe-md-0")} gap={3}>
            <Form.Group className="flex-grow-1">
              <Form.Label className="mb-0">
                <DynamicText path={`page.insights.query.label.${locale}`} />
              </Form.Label>
              <Form.Control
                value={query ?? ""}
                placeholder={placeholders[`page.insights.topics.placeholder.${locale}`]}
                onChange={(e) => setQuery(e.target.value)}
              />
            </Form.Group>
            <Button type="submit" tabIndex={undefined}>
              <Search />
            </Button>
          </Stack>
          <Dropdown
            show={show}
            drop="down"
            className={clsx(classes.form__filters, "p-3 pt-0 pt-md-3 p-md-3")}
            align="end"
            onMouseOver={() => setShow(true)}
            onMouseOut={() => setShow(false)}
          >
            <Dropdown.Toggle className="p-4" id="insights-filter-tags">
              <DynamicText path={`page.insights.topics.label.${locale}`} />
              <i>
                <span />
                <span />
                <span />
              </i>
            </Dropdown.Toggle>
            <Dropdown.Menu flip={false}>
              <Stack className="flex-row flex-wrap gap-2">
                {tags[locale].map((i, key) => (
                  <Dropdown.Item
                    key={key}
                    href={i === tag ? link("blog") : link("blog.tag", i.url_slug)}
                    className={clsx("text-nowrap", { active: tag && i.label === tag?.label })}
                  >
                    {i.label}
                  </Dropdown.Item>
                ))}
              </Stack>
            </Dropdown.Menu>
          </Dropdown>
        </Form>
      </Container>
      <Container>
        <Row>
          {item1 && (
            <Col xs={12} md={6}>
              <InsightCard item={item1} />
            </Col>
          )}
          {item2 && (
            <Col xs={12} md={6}>
              <InsightCard item={item2} />
            </Col>
          )}
        </Row>
        {rest && (
          <Row className="py-4 py-md-5">
            {rest.map((i) => (
              <Col key={i.id} xs={12}>
                <InsightItem item={i} />
              </Col>
            ))}
          </Row>
        )}
        <div className="ps-md-5 ms-md-4">
          {items.length > rest.length + 2 && (
            <Button variant="primary w-100" onClick={() => setPage(page + 1)} tabIndex={undefined}>
              Load more
            </Button>
          )}
        </div>
      </Container>
    </div>
  );
};
